function formTwoDigitArray(number) {
  const length = number.length;
  const result = [];

  // If the number length is odd, add a '0' at the beginning
  if (length % 2 !== 0) {
    number = "0" + number;
  }

  // Split the number into two-digit chunks and push them into the result array
  for (let i = 0; i < length; i += 2) {
    result.push(number.slice(i, i + 2));
  }

  return result;
}

export default formTwoDigitArray;
